<!--
    Summary:
        firstchoice.exhibition.web - mthfr-p7
    ChangeLog:
        wangn on 2020/12/6 added
-->
<template>
  <div class="v-mthfr-p7" title="mthfr-p7">
    <img-card class="card">
      <div slot="title" style="width:100%;">{{$t('Mthfr.P7_Title')}}</div>

      <div class="table-wrapper">
        <table id="cu-table">
          <thead></thead>
          <thead>
          <tr>
            <th>{{$t('Mthfr.P7_1_1')}}</th>
            <th>{{$t('Mthfr.P7_2_1')}}</th>
            <th>{{$t('Mthfr.P7_3_1')}}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{$t('Mthfr.P7_1_2')}}</td>
            <td>{{$t('Mthfr.P7_2_2')}}</td>
            <td rowspan="2">
              {{$t('Mthfr.P7_3_2')}}
              <br/>
              {{$t('Mthfr.P7_3_3')}}
            </td>
          </tr>
          <tr>
            <td>{{$t('Mthfr.P7_1_3')}}</td>
            <td>{{$t('Mthfr.P7_2_3')}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </img-card>
  </div>
</template>

<script>
  import ImgCard from "../img-card";

  export default {
    name: "mthfr-p7",
    components: {ImgCard}
  }
</script>

<style scoped lang="scss">
  .v-mthfr-p7 {

    .table-wrapper {
      border-bottom: 2px solid rgba(251, 207, 192, 0.2);
    }

  }
</style>




// WEBPACK FOOTER //
// src/view/genedetection/mthfr/mthfr-p7.vue